<div class="mt-3 offset-lg-3 col-lg-6 offset-md-2 col-md-8">
    <h1 class="text-center">Terms and Conditions</h1>
    <adapt-eula></adapt-eula>
</div>
